import React from 'react';
import './Logo.css';

const Logo = () => {
  return (
    <div className="logo-box">
      <h1 className="logo-z">Z</h1>
    </div>
  );
};

export default Logo;